import { AbstractPmsApiService } from "./abstract.service";
import { SubscriptionEmailNotification } from "../models";

/**
 * @class SubscriptionEmailNotificationPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SubscriptionEmailNotification>}
 */
export class SubscriptionEmailNotificationPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/subscription-email-notification(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SubscriptionEmailNotification}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SubscriptionEmailNotification(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<SubscriptionEmailNotification>>}
     */
    get (params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {integer} notificationId
     * @returns {Promise.<emailNotification>}
     */
    show(notificationId) {

        const url = this.url({
            id: notificationId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SubscriptionEmailNotification} emailNotification
     * @returns {Promise.<SubscriptionEmailNotification>}
     */
    update(emailNotification) {

        const url = this.url({
            id: emailNotification.id
        });

        return this.http
            .put(url, emailNotification.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {SubscriptionEmailNotification} emailNotification
     * @returns {Promise.<SubscriptionEmailNotification>}
     */
    revertToDefault(emailNotification) {
        
        const url = this.url({
            id: emailNotification.id
        });

        return this.http
            .get(url + '/revert', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {SubscriptionEmailNotification} emailNotification
     * @param {Array} recipients
     * @returns {Promise.<Boolean>}
     */
    sendTestEmail(emailNotification, recipients) {
        
        const url = this.url({
            id: emailNotification.id
        });
        
        return this.http
            .post(url + '/send-test-email', {recipients: recipients}, {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/subscription-email-notification.service.js